/* Samila Home - mega menu open/close.

   The theme opens the mega menu on :hover alone, so there is no way to put it
   away again - on a touch screen the hover state sticks until you tap
   something else. This turns the heading into a proper toggle:

     * click "Shop Posters" while the menu is open   -> closes it
     * click it again                                -> opens it
     * Escape, or a click/tap anywhere outside       -> closes it
     * hovering with a mouse                         -> works exactly as before

   Two classes drive it. .sh-mega-closed defeats the theme's hover rule,
   .sh-mega-open forces the panel open where there is no hover (touch).
   Moving the mouse off the item clears both so the next hover is normal. */
(function () {
  'use strict';

  var CLOSED = 'sh-mega-closed';
  var OPEN   = 'sh-mega-open';

  function items() {
    return document.querySelectorAll('.menu-lv-item.has-megamenu');
  }

  function closeAll(except) {
    items().forEach(function (li) {
      if (li === except) return;
      li.classList.remove(OPEN);
      li.classList.add(CLOSED);
    });
  }

  function init() {
    document.addEventListener('click', function (e) {
      var action = e.target.closest('.has-megamenu > .menu-lv-1__action, .has-megamenu > a.menu-lv-1__action');

      if (action) {
        var li = action.closest('.menu-lv-item.has-megamenu');
        if (!li) return;

        // the heading is a toggle, never a link - everything it would go to
        // is inside the panel anyway
        e.preventDefault();
        e.stopPropagation();

        // on a touch screen the tap itself applies :hover, so the panel is
        // already showing by the time the click lands - the first tap should
        // pin it open rather than shut it again
        var touch = e.pointerType === 'touch' || e.pointerType === 'pen';
        var wasClosed = touch ? !li.classList.contains(OPEN) : li.classList.contains(CLOSED);
        closeAll(li);
        if (wasClosed) {
          li.classList.remove(CLOSED);
          li.classList.add(OPEN);
        } else {
          li.classList.remove(OPEN);
          li.classList.add(CLOSED);
        }
        return;
      }

      // a click anywhere outside the panel closes it too
      if (!e.target.closest('.menu-lv-item.has-megamenu')) closeAll();
    }, true);

    // leaving the item with the mouse resets it, so hover keeps working
    items().forEach(function (li) {
      li.addEventListener('mouseleave', function () {
        li.classList.remove(CLOSED);
        li.classList.remove(OPEN);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    // scrolling away from a stuck panel should also dismiss it
    var lastY = window.pageYOffset;
    window.addEventListener('scroll', function () {
      if (Math.abs(window.pageYOffset - lastY) < 60) return;
      lastY = window.pageYOffset;
      closeAll();
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
